import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SeychellesFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15963'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15963)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 0H0V14H20V9.33333L0 14L20 4.66667V0Z'
					fill='url(#paint0_linear_2332_15963)'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0H6.66667L0 14V0Z'
					fill='#0858B4'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.3333 0H20V4.66667L0 14L13.3333 0Z'
					fill='#ED3535'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 14V9.33337L0 14H20Z'
					fill='#08964F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66667 0H13.3333L0 14L6.66667 0Z'
					fill='#FFDD67'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_15963'
					x1='0'
					y1='0'
					x2='0'
					y2='14'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#1DBE4F' />
					<stop
						offset='1'
						stopColor='#159B3F'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default SeychellesFlagIcon;
